module.exports = __webpack_public_path__ + "profile-4-d-4P5.png";